import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const MiscellaneousLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="18.54"
        y="29.37"
        width="69.87"
        height="69.5"
        rx="19.81"
        transform="translate(-14.63 15.82) rotate(-14.83)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_19_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(19 44) rotate(-14.83)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_20_"
        x1="1291.531"
        x2="1368.728"
        y1="432.878"
        y2="432.878"
        gradientTransform="rotate(3.551 1340.948 459.91) scale(1.00002)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="104.78"
        y="16.71"
        width="68.24"
        height="67.88"
        rx="19.81"
        transform="translate(-3.95 12.53) rotate(-5.09)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_20_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(108.5 25.5) rotate(-5.09)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(200 12) rotate(10)"
    >
      <linearGradient
        id="SVGID_17_"
        x1="1214.409"
        x2="1295.185"
        y1="504.259"
        y2="504.259"
        gradientTransform="rotate(7.406 1239.032 502.913)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_17_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(20 118) rotate(-14.83)"
    >
      <linearGradient
        id="SVGID_17_"
        x1="1214.409"
        x2="1295.185"
        y1="504.259"
        y2="504.259"
        gradientTransform="rotate(7.406 1239.032 502.913)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_17_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(120 90) rotate(5.84)"
    >
      <linearGradient
        id="SVGID_17_"
        x1="1214.409"
        x2="1295.185"
        y1="504.259"
        y2="504.259"
        gradientTransform="rotate(7.406 1239.032 502.913)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_17_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(208 89) rotate(12)"
    >
      <linearGradient
        id="SVGID_17_"
        x1="1214.409"
        x2="1295.185"
        y1="504.259"
        y2="504.259"
        gradientTransform="rotate(7.406 1239.032 502.913)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="url(#SVGID_17_)"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-miscellaneous"
      transform="translate(967, 65)"
    >
      <g id="a7d6d07c-c32c-4384-bff7-de91d271508b" data-name="miscellaneous">
        <g>
          <path
            d="M82.81,195.45c0,34.36,67.61,65.59,120.18,78.08s27.54,65.59,37.56,90.57l22.53,56.22h75.11s-15-31.23,30.05-65.59,82.62-65.58,90.13-87.44S516,195.45,516,195.45Z"
            fill="#9e5243"
          />
          <path
            d="M540.09,149.06,291.44,169.45c-10.48,18.15-24.83,35-44.31,45.35-28,15.3-61,12.06-90.6,23.84,55.06-2.52,88.65-6.82,101.12-1.48,18.41,7.89,179.2,42.3,256-10.41S540.09,149.06,540.09,149.06Z"
            fill="#0e3b68"
            opacity="0.32"
          />
          <path
            d="M1,175c-10.11-32.56,214.33-53.85,233.13-60.58s244.37-23.57,288.23,0,49,87.37-53.26,117.81C361.75,264.2,342.59,209.6,252.56,224c-74.33,11.86-134.39-5.17-187.65-22S13.49,215.44,1,175Z"
            fill="#f2aa68"
          />
          <path
            d="M551,160.75a48,48,0,0,1-4.35,18.38,57.71,57.71,0,0,1-4.63,8.35,77.49,77.49,0,0,1-5.82,7.59A93.21,93.21,0,0,1,522.09,208,134.53,134.53,0,0,1,506,218.28,205.49,205.49,0,0,1,470.83,233a255.34,255.34,0,0,1-37.05,9.14,175.86,175.86,0,0,1-38.31,2.35,198.59,198.59,0,0,1-37.91-6c-12.37-3-24.38-6.78-36.49-9.5a175,175,0,0,0-36.65-4.64,178,178,0,0,0-18.47.66c-3.07.25-6.14.62-9.21,1l-9.32,1.36c-3.15.49-6.32.82-9.48,1.22s-6.34.68-9.52.9c-6.35.55-12.72.84-19.09,1a338.67,338.67,0,0,1-75.8-7.55c-12.42-2.63-24.7-5.81-36.84-9.35s-24.16-7.55-36.06-11.48a125.22,125.22,0,0,0-18.07-4.39A82.59,82.59,0,0,0,24,196.91l-4.7.33a37.25,37.25,0,0,1-4.86.09,9.52,9.52,0,0,1-4.87-1.57A11.75,11.75,0,0,1,6.32,192a46.39,46.39,0,0,1-3.65-8.82c-1-3-1.84-6-2.67-9.08,1,3,2.11,5.94,3.29,8.85a48.5,48.5,0,0,0,4.13,8.36,10.41,10.41,0,0,0,3.05,3.14,7.67,7.67,0,0,0,4.09,1c3,0,6.11-.62,9.26-.95a85.42,85.42,0,0,1,19.18,0,117.3,117.3,0,0,1,18.8,3.71L80,203.5c6,1.74,12.1,3.39,18.16,5,12.12,3.24,24.33,6.1,36.62,8.4s24.65,4.13,37.08,5.19a318.82,318.82,0,0,0,37.34,1.1c6.22-.17,12.44-.48,18.64-1,3.1-.24,6.19-.61,9.29-.93s6.18-.74,9.25-1.23l9.37-1.41c3.18-.43,6.37-.82,9.57-1.1a167.59,167.59,0,0,1,19.28-.71,183.08,183.08,0,0,1,38.17,5c12.47,2.88,24.53,6.64,36.59,9.81a191.2,191.2,0,0,0,36.54,6.31,180.12,180.12,0,0,0,37-1.53,272.14,272.14,0,0,0,36.5-8A204.94,204.94,0,0,0,504.29,215c11.12-5.54,21.68-12.44,30.38-21.36a75.72,75.72,0,0,0,6-7.1,59.85,59.85,0,0,0,4.93-7.92A47.55,47.55,0,0,0,551,160.75Z"
            fill="#ffefd2"
          />
          <path
            d="M485.31,125.31c-114.35,0-107,27.88-165.71,7.66-58.42-20.11-133.44-3.92-161.24,23.19s-98.87-6.77-95.78,27.12,120.49-16.95,169.93,0,178.9,24.77,222.15,34.94S522.38,125.31,485.31,125.31Z"
            fill="#e2974b"
          />
          <g>
            <g>
              <path
                d="M66.9,124.15c-3.27-.55-11.74-2.77-21.57,0s-3.53,9.62,1.17,10.36,21.79,1.61,24.68-.64S74.49,125.44,66.9,124.15Z"
                fill="#f44e92"
              />
              <path
                d="M72.56,128.64s9.62,22-3.63,38.24H44.69s-13.16-16.7-4.55-37.83C64.83,130.47,72.56,128.64,72.56,128.64Z"
                fill="#f44e92"
              />
              <ellipse
                cx="56.81"
                cy="128.62"
                rx="12.12"
                ry="2.48"
                fill="#8e1442"
              />
              <ellipse
                cx="56.81"
                cy="166.85"
                rx="12.12"
                ry="2.48"
                fill="#ff1555"
              />
            </g>
            <ellipse
              cx="55.1"
              cy="174.33"
              rx="28.83"
              ry="6.99"
              fill="#8e1442"
              opacity="0.57"
            />
            <path
              d="M37.4,147.35a38.16,38.16,0,0,1,2.73-18.26,30.78,30.78,0,0,0,11.61,4.46c3.74,5.66,4.59,5.77,4.59,5.77a8.58,8.58,0,0,0,6-5.77A26.26,26.26,0,0,0,73,129.66,47.17,47.17,0,0,1,75.62,151L46,155.34Z"
              fill="#8e1442"
              opacity="0.58"
            />
            <g>
              <path
                d="M43.93,133.38c-2.92.22-10.65.14-18.47,4.62s-1,9,3.22,8.62,19-3.3,21-5.83S50.7,132.85,43.93,133.38Z"
                fill="#f44e92"
              />
              <path
                d="M49.74,136s12.94,16.78,5.08,33.51l-20.76,5.19s-14.84-11.47-12-31.41C43.51,139.23,49.74,136,49.74,136Z"
                fill="#f44e92"
              />
              <ellipse
                cx="36.25"
                cy="139.36"
                rx="10.7"
                ry="2.19"
                transform="translate(-32.72 12.95) rotate(-14.04)"
                fill="#8e1442"
              />
              <ellipse
                cx="44.43"
                cy="172.1"
                rx="10.7"
                ry="2.19"
                transform="translate(-40.42 15.92) rotate(-14.04)"
                fill="#f44e92"
              />
            </g>
            <path
              d="M50.84,137.61c2.41,3.72,7.79,13.49,6.23,24.37a12.15,12.15,0,0,1-2.66-2S49,143.66,40.13,144.48C40.13,144.48,47.8,141.75,50.84,137.61Z"
              fill="#8e1442"
              opacity="0.45"
            />
            <g>
              <path
                d="M77.83,143c-2.47-.86-8.79-3.71-16.82-2.84s-4,7-.45,8.23,16.78,4.12,19.32,2.75S83.58,145,77.83,143Z"
                fill="#f44e92"
              />
              <path
                d="M81.66,147.29s4.59,18.42-7.88,29.34l-18.9-3.2s-8.06-14.75,1.44-30.1C75.38,147.69,81.66,147.29,81.66,147.29Z"
                fill="#f44e92"
              />
              <ellipse
                cx="69.37"
                cy="145.19"
                rx="1.96"
                ry="9.59"
                transform="translate(-85.35 189.39) rotate(-80.4)"
                fill="#8e1442"
              />
              <ellipse
                cx="64.33"
                cy="175.01"
                rx="1.96"
                ry="9.59"
                transform="translate(-118.95 209.26) rotate(-80.4)"
                fill="#f44e92"
              />
            </g>
            <path
              d="M70.39,150.73C82,151.89,82,148.92,82,148.92c.78,4.75,2,18.75-8.2,27.71l-1.29-.22C79.78,154.6,70.39,150.73,70.39,150.73Z"
              fill="#8e1442"
              opacity="0.45"
            />
            <path
              d="M50.35,172.54c-10.55,2.63-11.32,3-14.63,2.77-.26-.13-2-.92-2.22-1.06a34.23,34.23,0,0,1-4.29-4.6C36.25,172.64,43.45,172.87,50.35,172.54Z"
              fill="#8e1442"
              opacity="0.45"
            />
          </g>
          <g>
            <g opacity="0.25">
              <path
                d="M445.2,184.45s10.64-8.46,11.86-12.36,2.9-4,1.37-4.59c-4.59-1.83-3.42-7.45,6.86-4,12.84,4.32,11.75,9.59,2.12,8.12-2.35,1.6-3.15,2.67-4.36,3.54-1,.69,1.5,6-15.64,11.51Z"
                fill="#531063"
              />
              <ellipse
                cx="465.56"
                cy="167.18"
                rx="2.17"
                ry="7.56"
                transform="translate(159.18 555.55) rotate(-71.48)"
                fill="#531063"
              />
              <path
                d="M458.16,179.5c3.19-.41,5.49-1.56,7.65-2s4.52-2.39,6.82-3.22,9.69-2.78,6.89-8.76c-3.44-2.66.65-5.81,10-2.65s11,5.8,8.86,7.18c-1.42.91-1.84,4.42-11,5.22s-13.87,2.69-14.48,3.4-2.61,4.48-9.78,5.84-17,2.54-17,2.54Z"
                fill="#531063"
              />
              <ellipse
                cx="489.14"
                cy="166.37"
                rx="2.17"
                ry="7.56"
                transform="translate(176.04 577.35) rotate(-71.48)"
                fill="#531063"
              />
              <path
                d="M467.78,181.29c3.24-.53,8.48.47,12.27.66,1.7.09,4.08.5,6.55.74,3.87.39,7.18-.83,8-2.93,1-2.42,6.15-3.93,9.6-.31,3.24,3.41,5.36,7.59,2.09,9.75-1.73,1.16-4.77.43-6.73-.76a11.32,11.32,0,0,0-6.13-1.41,31.19,31.19,0,0,1-9.28-.86c-3.56-.8-14.23-1.33-24.23,1.64s-12.08,1.35-12.25.85a16,16,0,0,1-.31-2Z"
                fill="#531063"
              />
              <ellipse
                cx="501.92"
                cy="183.81"
                rx="3.09"
                ry="5.29"
                transform="translate(-5.76 351.06) rotate(-38.35)"
                fill="#531063"
              />
              <path
                d="M466.49,183.55a12.79,12.79,0,0,0,6.37-4.9c.61-.71,5.3-2.6,14.48-3.4,7.53-.66,9.24-3,10.05-4.45a20.36,20.36,0,0,1-9.15-.78c1.4,1.59,2,2.39-.65,3.32s-4-.45-11.42,3-6.68,6-11.56,6.53c-3.29.36-9.66,2.27-13.45,3.48,1.72-.24,3.74-.52,5.81-.85Z"
                fill="#531063"
                opacity="0.47"
              />
              <g>
                <path
                  d="M479.66,165.8a4.52,4.52,0,0,1-.41,4.79c2.42-1.59,6.16-1.44,6.16-1.44A21.24,21.24,0,0,1,479.66,165.8Z"
                  fill="#531063"
                  opacity="0.47"
                />
                <polygon
                  points="477.92 171.86 477.92 171.86 477.92 171.86 477.92 171.86"
                  fill="#531063"
                />
              </g>
              <path
                d="M460,187.81c10-3,20.67-2.44,24.23-1.64,5.19,1.44,12.31.46,15.1,1.74,0,0-3.06-2.65-3.47-4.39-.76,2-1.49,2.76-5.71,2.79s-5.52-.9-9.56-1.35a74.27,74.27,0,0,0-13.4.18c-2.93.35-12.5,3.42-14.74,3.47s-4.7,0-4.7,0l2.26.88C451.74,189.66,454.78,189.35,460,187.81Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M449.41,182.25c2.34-.62,2-3.25,5.25-5s2.68-3.42,4.13-5.43,2.14-1.65,3.87-2.22A11.83,11.83,0,0,1,459,168.1h0a17.65,17.65,0,0,0-2,4c-1.22,3.9-11.86,12.36-11.86,12.36C446.33,184.26,447.08,182.87,449.41,182.25Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M460.64,180.36a50,50,0,0,0,8.62-3c1.69-.77,9.54-3.93,9.12-4.69a6.33,6.33,0,0,0-.49-.74A15.7,15.7,0,0,1,474,173.8h0s-3.33,1.66-5.84,2.77a9.77,9.77,0,0,1-2.32.91l-.63.15c-2,.53-.86.79-3.75,1.16C460.22,179.55,458.53,180.7,460.64,180.36Z"
                fill="#531063"
              />
              <path
                d="M505.2,183.23c-1.23-2.32-3.54-4.08-5.37-4a2,2,0,0,0-1.92,1.76C500.31,179.59,503.6,181.88,505.2,183.23Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M490.57,164.58c-3.9-1.44-7.7-1.8-8.49-.81-.28.35-.13.82.33,1.35,1.15-2.42,12.26,1.8,13,2.09A16.1,16.1,0,0,0,490.57,164.58Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M466.44,165.39l-.7-.42c-3.43-1.07-6.53-1.27-7.24-.39-.33.42-.05,1,.64,1.66.21-.06.71.22,1.77,1.25l.2.11C458.72,163.54,466.44,165.39,466.44,165.39Z"
                fill="#531063"
                opacity="0.47"
              />
            </g>
            <g>
              <path
                d="M443.38,187.76s-6.55-14.63-10.71-18.54-3.73-5.26-4.92-4.54c-3.53,2.15-9.71-3-2.52-8.32,9-6.61,14.75-1.76,10.08,4.54,1.14,3,2.14,4.46,2.78,6,.5,1.26,7.44,3.41,8.57,20.81Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="429.58"
                cy="158.95"
                rx="6.24"
                ry="2.96"
                transform="translate(-16.07 264.77) rotate(-33.66)"
                fill="#170"
              />
              <path
                d="M441.62,174c.5-2.77-.13-5.42,0-7.44s-1.39-5.29-1.64-7.69-.25-9.58-8.07-12c-4.15.64-6.56-4.91,0-9.7S442,133.13,443,135.83c.62,1.78,4.56,4.77,2.67,12.46s-1.13,12.74-.5,13.74,4.41,5.43,3.78,12-2.27,15-2.27,15Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="435.88"
                cy="140.16"
                rx="6.24"
                ry="2.96"
                transform="translate(-4.6 265.12) rotate(-33.66)"
                fill="#170"
              />
              <path
                d="M446.66,168c.38-2.9,3.15-6.18,4.54-9,.62-1.25,1.83-2.77,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.67-7.73,2.6-7.63,5,.09,10.46,1.64,12,5.8.8,2.21-1,4-3,4.6a5.49,5.49,0,0,0-3.51,3.66,14.93,14.93,0,0,1-3.86,6.49c-2,2.14-5.93,10-5.55,19.92s-2.14,10.34-2.77,10.09-2.4-1.26-2.4-1.26Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="460.09"
                cy="143.56"
                rx="2.96"
                ry="6.24"
                transform="matrix(0.3, -0.95, 0.95, 0.3, 185.88, 539.92)"
                fill="#170"
              />
              <path
                d="M448.88,170.67a18.78,18.78,0,0,0-3.73-8.64c-.63-1-1.39-6.05.5-13.74,1.55-6.3-.62-9.39-2.08-11.13a10,10,0,0,1-3.72,6.47c2.27.12,3.41.25,3.66,3s-1.77,2.78,0,11.1,4.92,9.71,4,13.87c-.59,2.8-.33,9.16-.09,13,.26-1.51.54-3.28.81-5.12Z"
                fill="#11366d"
                opacity="0.47"
              />
              <g>
                <path
                  d="M432.31,147a10.35,10.35,0,0,1,5.43,4,8.29,8.29,0,0,1,.22-5.85A13.83,13.83,0,0,1,432.31,147Z"
                  fill="#11366d"
                  opacity="0.47"
                />
                <polygon
                  points="438.82 152.98 438.82 152.98 438.82 152.98 438.82 152.98"
                  fill="#170"
                />
              </g>
              <path
                d="M451.83,178.93c-.38-10,3.53-17.78,5.55-19.92,3.28-2.9,4.33-9.13,6.67-10.3,0,0-4,.34-6.17-.67,2.15,2.14,2.75,3.24,1.49,6.52s-2.75,3.57-4.51,6.34A37.85,37.85,0,0,0,451,171.36c-.51,2.53.12,12.23-.51,14s-1.38,3.66-1.38,3.66l1.71-1.08C451.46,186.69,452,184.1,451.83,178.93Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M442.12,182.84c0-2.27-3.15-4-4.16-7.82s-3.15-4.66-5-7.31-1.26-2.9-1.39-4.67a6.64,6.64,0,0,1-2.9,1.63h0a39.6,39.6,0,0,0,4,4.55c4.16,3.91,10.71,18.54,10.71,18.54C443.51,186.75,442.12,185.11,442.12,182.84Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M443.38,172.75c.26-1.89-.5-7.06-.88-8.95s-1.64-10.34-2.65-10.59a9.85,9.85,0,0,0-1-.19,15.57,15.57,0,0,1,1,4.47h0s.91,3.84,1.43,6.61a8.72,8.72,0,0,1,.34,2.47c0,.18,0,.38,0,.61,0,1.93.66,1.27.21,3.77C442.31,172.46,443.13,174.64,443.38,172.75Z"
                fill="#86e04b"
              />
              <path
                d="M460.42,140.59c-3.07-.81-5.83-.36-6.29,1.11-.27.87.33,1.9,1.46,2.82C454.68,141.59,458.36,140.8,460.42,140.59Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M434.24,137.69c-2.87,1.91-4.46,4.57-3.55,5.93a2.07,2.07,0,0,0,1.67.77c-2.46-2.73,5.86-8.08,6.44-8.45A10.1,10.1,0,0,0,434.24,137.69Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M427.76,156.9l-.7.23c-2.3,1.82-3.49,4.06-2.68,5.27a2.3,2.3,0,0,0,2.12.77c0-.2.48-.38,2-.41l.2-.07C423.23,161.44,427.76,156.9,427.76,156.9Z"
                fill="#11366d"
                opacity="0.47"
              />
            </g>
            <path
              d="M454.47,148.06a4.64,4.64,0,0,1,.67,2.4,8.56,8.56,0,0,1-.28,2.52,15.93,15.93,0,0,1-2.06,4.56c-1.73,2.75-3.5,5.45-5.43,8.11a34.08,34.08,0,0,1,2-4.49c.75-1.45,1.58-2.86,2.44-4.24a22.14,22.14,0,0,0,2.18-4.21A8,8,0,0,0,454.47,148.06Z"
              fill="#86e04b"
            />
            <path
              d="M456.44,138.76c-.66.37-1.3.7-1.87,1.07a3.87,3.87,0,0,0-1.32,1.24,1.9,1.9,0,0,0,0,1.61c.1.3.26.61.39.94a10.15,10.15,0,0,1,.5,1,8.32,8.32,0,0,1-1-.64,4.47,4.47,0,0,1-.76-.9,2.5,2.5,0,0,1-.17-2.56,3.48,3.48,0,0,1,2-1.5A4.84,4.84,0,0,1,456.44,138.76Z"
              fill="#86e04b"
            />
            <path
              d="M431.43,139.34c-.41.64-.82,1.23-1.15,1.82a3.72,3.72,0,0,0-.59,1.72,1.9,1.9,0,0,0,.72,1.44c.22.23.51.42.78.65a8.32,8.32,0,0,1,.9.64,7.23,7.23,0,0,1-1.13-.12,4.86,4.86,0,0,1-1.1-.44,2.5,2.5,0,0,1-1.34-2.18,3.51,3.51,0,0,1,1-2.25A4.92,4.92,0,0,1,431.43,139.34Z"
              fill="#86e04b"
            />
            <path
              d="M424.83,157.49c-.34.71-.66,1.38-.91,2a4.24,4.24,0,0,0-.3,1.9,2.53,2.53,0,0,0,.87,1.57c.22.25.54.43.81.68s.62.41.94.66a9.67,9.67,0,0,1-1.18-.13,5.56,5.56,0,0,1-1.13-.48,2.94,2.94,0,0,1-1.47-2.15,3.77,3.77,0,0,1,.65-2.46A4.88,4.88,0,0,1,424.83,157.49Z"
              fill="#86e04b"
            />
          </g>
        </g>
        <g>
          <ellipse cx="135.7" cy="184.32" rx="19" ry="7" fill="#894e2e" />
          <path
            d="M114.22,180.39c0,3.42,6,6.19,13.37,6.19S141,183.81,141,180.39c0-.71-.05-2.78-.05-2.78s-7.47-3.42-13.32-3.42-13.34,3.36-13.34,3.36S114.22,179.64,114.22,180.39Z"
            fill="#98baf5"
          />
          <ellipse cx="127.59" cy="177.79" rx="13.37" ry="6.2" fill="#b0dff6" />
          <path
            d="M128,176.25c-1.1,1.05-11-2.48-11-2.48s3.69-1.44,4.35-1.61a37.7,37.7,0,0,1,7.71,2.48Z"
            fill="#90a3f4"
          />
          <path
            d="M127.41,176.9h2.17V21.44L127.6,0l-2,21.44V175A1.86,1.86,0,0,0,127.41,176.9Z"
            fill="#b0dff6"
          />
          <path
            d="M127.6,0l.91,9.87-1.09,11.75V176.9h0a1.86,1.86,0,0,1-1.82-1.9V21.44Z"
            fill="#98baf5"
          />
          <path
            d="M154.53,42.09s-.43,16.44-8.36,40c-5.59,16.58-10.64,54.31-7.44,63.52-8.11-1-20.6-14.65-20.6-14.65s-10.8,8.77-10.8,16.58c-13-12.42-17.72-32-17.93-58.29C89.23,66,103.94,42.39,103.94,42.39Z"
            fill="#542cb7"
          />
          <path
            d="M129.58,21.44V32a3.89,3.89,0,0,1-2.48.56c-.38,0-1.12-.22-1.5-.26V21.44L127.6,0Z"
            fill="#d2ddef"
          />
          <path
            d="M127.6,0,128,4.61,126.59,20l-.2,11.22a12,12,0,0,0,1.68.06,7.1,7.1,0,0,0,1.51-.29v1a3.89,3.89,0,0,1-2.48.56c-.38,0-1.12-.22-1.5-.26V21.44Z"
            fill="#bfd0ee"
          />
          <path
            d="M125.41,31.66c0,.53,1,.95,2.17.95s2.17-.42,2.17-.95"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="95.79"
            y="38.66"
            width="66.54"
            height="3.61"
            rx="1.8"
            transform="matrix(-1, -0.01, 0.01, -1, 257.71, 82.24)"
            fill="#b0dff6"
          />
          <path
            d="M154.48,42.46s-1.08,15.13-9,38.66c-5.59,16.58-11,55-7.79,64.25-8.12-1-20.26-15.37-20.26-15.37s-10.79,8.76-10.79,16.58c-13-12.42-17.73-32.05-17.93-58.29-.17-23.24,14.54-46.84,14.54-46.84Z"
            fill="#aa67e6"
          />
          <path
            d="M152.28,38.88a2.45,2.45,0,0,0,.3,3.67c-7,0-17.09-.14-17.09-.14s-2.13-1.88,0-3.65C141.06,38.61,152.28,38.88,152.28,38.88Z"
            fill="#aa67e6"
          />
          <path
            d="M119,38.46a2.44,2.44,0,0,0,.31,3.66c-7,0-17.09-.14-17.09-.14s-2.14-1.88,0-3.65C107.76,38.18,119,38.46,119,38.46Z"
            fill="#aa67e6"
          />
          <path
            d="M124.9,30.66c0,.61,1.13,1.11,2.53,1.11s2.52-.5,2.52-1.11"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.8,39.9a1.57,1.57,0,0,1,.47-1.11,1.58,1.58,0,0,0,1.5,1.14l63.35.65a1.55,1.55,0,0,0,1.14-.46,1.5,1.5,0,0,1,.08.47V41a1.6,1.6,0,0,1-1.61,1.58l-63.35-.66a1.58,1.58,0,0,1-1.58-1.6Z"
            fill="#98baf5"
            opacity="0.31"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M106.5,100.77l9.21-3.86a2.26,2.26,0,0,1,2.08.19l8.4,5.4a2.25,2.25,0,0,0,3.46-2.08l-.82-10a2.27,2.27,0,0,1,.82-1.93l7.73-6.32a2.25,2.25,0,0,0-.91-3.93L126.76,76a2.25,2.25,0,0,1-1.59-1.37l-3.62-9.31a2.25,2.25,0,0,0-4-.35l-5.18,8.53a2.24,2.24,0,0,1-1.8,1.08l-10,.57A2.25,2.25,0,0,0,99,78.86l6.51,7.56a2.28,2.28,0,0,1,.47,2l-2.54,9.65A2.25,2.25,0,0,0,106.5,100.77Z"
            fill="#f4da34"
          />
          <path
            d="M116.17,47.47a61.92,61.92,0,0,0-17.55,2.66c2.51-5.22,4.62-8.68,4.62-8.68l51.24,1a117.31,117.31,0,0,1-3,17.33C141.91,52.47,128.77,47.47,116.17,47.47Z"
            fill="#7b2cda"
          />
          <ellipse
            cx="120.75"
            cy="73.3"
            rx="2.15"
            ry="6.5"
            transform="translate(-12.95 27.73) rotate(-12.44)"
            fill="#fbf29f"
          />
        </g>
        <g className="text" transform="translate(335 205)">
          <path
            fill="#ffffff"
            d="M20.1,14.4c-0.3-2.3-0.8-4.5-1.3-6.6c-0.1-0.5-0.3-1.1-0.4-1.6c0,0,0,0,0,0c-0.5-1.6-1-3.2-1.5-4.7
            c-0.1-0.4-0.3-0.7-0.5-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.1,0-0.2,0-0.3,0h-0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.7,0.1
            c-0.7,0.1-1.1,0.4-1.3,1c-0.5,1.2-0.9,2.4-1.2,3.6c-0.3,1.2-0.6,2.4-0.9,3.6C9.8,7.2,9.4,6,9.1,4.8C8.7,3.6,8.3,2.5,7.8,1.3
            C7.6,1,7.5,0.7,7.3,0.5C7.1,0.4,6.8,0.3,6.5,0.3c-0.1,0-0.2,0-0.3,0H5.9c-0.2,0-0.4,0-0.7,0c-0.2,0-0.5,0-0.7,0.1
            C4.1,0.4,3.9,0.5,3.7,0.6C3.5,0.8,3.4,1,3.3,1.3C2.6,3.6,1.9,5.7,1.4,7.8c-0.5,2.1-1,4.2-1.3,6.4c0,0.1,0,0.2,0,0.2
            c0,0.1,0,0.2,0,0.2c0,0.5,0.3,0.8,0.8,0.9c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.7,0,1.1,0c0.5,0,0.8-0.1,0.9-0.3C3.9,15.3,4,15,4,14.7
            c0.2-1.6,0.4-3.1,0.6-4.5c0.2-1.4,0.5-2.7,0.8-4C5.8,7.6,6.2,9,6.5,10.4c0.3,1.3,0.7,2.5,1.2,3.8c0,0.1,0.1,0.2,0.1,0.3
            c0.1,0.4,0.3,0.6,0.6,0.8c0.2,0.2,0.6,0.3,1,0.3c0.5,0,1-0.1,1.6-0.2c0.3-0.1,0.6-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.7
            c0.5-1.3,0.9-2.7,1.2-4c0,0,0,0,0,0c0.3-1.3,0.6-2.7,0.9-4c0.2,1,0.5,1.9,0.7,2.8c0.1,0.5,0.2,1.1,0.3,1.6c0.3,1.5,0.6,2.9,0.8,4.4
            c0.1,0.4,0.2,0.6,0.5,0.7c0.2,0.1,0.5,0.1,0.9,0.1s0.7,0,1.1-0.1c0.4,0,0.7-0.1,1-0.2c0.4-0.1,0.6-0.4,0.6-0.9
            C20.1,14.6,20.1,14.5,20.1,14.4z"
          />
          <path
            fill="#ffffff"
            d="M25.4,1.1c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.1-0.2-0.2-0.3-0.2h0c-0.1-0.1-0.2-0.1-0.4-0.1
            C24.1,0,23.7,0,23.3,0c-0.8,0-1.3,0.2-1.6,0.5c-0.3,0.3-0.5,0.8-0.5,1.5c0,0.4,0,0.8,0.1,1c0,0.1,0.1,0.2,0.1,0.3
            c0.1,0.1,0.1,0.2,0.2,0.3C21.8,3.9,22.1,4,22.3,4c0.3,0.1,0.6,0.1,1,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.5-0.2,0.7-0.4
            c0.2-0.2,0.3-0.4,0.3-0.6c0.1-0.2,0.1-0.5,0.1-0.8C25.6,1.8,25.5,1.4,25.4,1.1z M25.1,5.3c-0.1-0.1-0.2-0.2-0.4-0.2
            c-0.1,0-0.2,0-0.3,0H24c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0.1-0.8,0.1c-0.3,0-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
            c-0.1,0.8-0.1,1.7-0.1,2.5c0,0.8,0,1.6,0,2.4c0,0.5,0,1,0,1.5c0,0.5,0,1,0.1,1.5c0,0.4,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3
            c0.4,0,0.8,0.1,1.2,0.1c0.3,0,0.5,0,0.6-0.1c0.2,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.4c0-0.2,0-0.3,0-0.6
            c0.1-1.4,0.2-2.8,0.2-4.2c0-1.3,0.1-2.8,0.1-4.3C25.2,5.6,25.1,5.4,25.1,5.3z"
          />
          <path
            fill="#ffffff"
            d="M32.2,8.5c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
            C35,8,35,7.6,35.1,7.2c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3C34,5.1,33.6,4.9,33,4.9
            c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7C27.6,6,27.3,6.3,27,6.7c-0.3,0.4-0.4,0.9-0.4,1.4
            c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5c0.3,0.1,0.6,0.3,0.8,0.4
            c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1c-0.3-0.1-0.6-0.2-0.8-0.3
            c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.4,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.2-0.1,0.3-0.1,0.5
            c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2c0.6-0.2,1.1-0.4,1.5-0.6
            c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.6-0.1-1-0.4-1.4c-0.2-0.4-0.5-0.7-0.9-1C33.4,10,33,9.8,32.6,9.6
            c-0.4-0.2-0.8-0.3-1.2-0.5C31,9,30.7,8.8,30.4,8.7c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
            c0.2,0,0.4,0,0.7,0.1v0.2C32.1,8.2,32.1,8.4,32.2,8.5z"
          />
          <path
            fill="#ffffff"
            d="M46.3,13.6c0-0.1-0.1-0.2-0.1-0.4c-0.1-0.2-0.2-0.4-0.2-0.5c-0.1-0.2-0.2-0.3-0.3-0.5
            c-0.2-0.3-0.3-0.4-0.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.2-0.6,0.2
            c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.8
            c-0.1-0.3-0.2-0.6-0.2-1c0-0.4,0.1-0.7,0.2-1C40,9,40.2,8.7,40.5,8.5C40.7,8.3,41,8.1,41.4,8c0.3-0.1,0.7-0.2,1.1-0.3
            c0,0.2,0,0.4,0,0.7c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.4,0.9,1,1c0.3,0.1,0.7,0.1,1.2,0.1c0.3,0,0.5-0.1,0.6-0.2
            c0.1-0.1,0.2-0.3,0.2-0.6c0.1-0.5,0.1-1,0.1-1.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4-0.1-0.7c0-0.4-0.1-0.7-0.3-0.9
            c-0.1-0.2-0.4-0.3-0.7-0.5c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4,0-0.7-0.1-1-0.1c-0.8,0-1.7,0.1-2.4,0.4c-0.8,0.3-1.5,0.7-2.1,1.2
            c-0.6,0.5-1.1,1.1-1.5,1.8c-0.4,0.7-0.6,1.4-0.6,2.2c0,0.3,0,0.6,0.1,0.9c0.1,0.4,0.2,0.7,0.3,1.1s0.4,0.8,0.6,1.2
            c0.3,0.4,0.6,0.8,1.1,1c0.4,0.3,1,0.6,1.7,0.8c0.7,0.2,1.4,0.3,2.3,0.3c0.4,0,0.8,0,1.1-0.1c0.4-0.1,0.8-0.1,1.1-0.3
            c0.4-0.1,0.7-0.2,1-0.4c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.2,0.3-0.4,0.3-0.6C46.3,13.8,46.3,13.7,46.3,13.6z"
          />
          <path
            fill="#ffffff"
            d="M57.8,8.3c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
            c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
            c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
            c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5C57,12.2,57,12.1,56.9,12c-0.1-0.1-0.1-0.1-0.3-0.1
            c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
            c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
            c0.1-0.1,0.1-0.3,0.1-0.5C58.1,9.3,58,8.9,57.8,8.3z M52.6,9.3c-0.7,0.1-1.4,0.1-2,0.1C50.7,9,51,8.6,51.5,8.3
            c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C54,9.1,53.3,9.2,52.6,9.3z"
          />
          <path
            fill="#ffffff"
            d="M63,2L63,2c0-0.4,0-0.7,0-1c0-0.3,0-0.6-0.1-0.7c-0.1-0.1-0.2-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
            c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.1,0.3-0.2,0.7c0,0.1,0,0.2,0,0.3c-0.1,1.2-0.2,2.4-0.2,3.7
            c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
            h0.6c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.2-2.3s0.1-1.8,0.1-2.8c0-1,0-2,0.1-3.1
            s0-2.1,0-3.1C63,2.7,63,2.4,63,2z"
          />
          <path
            fill="#ffffff"
            d="M68.6,2c0-0.3,0-0.7,0-1c0-0.3,0-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
            c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.4,0.3c-0.1,0.2-0.2,0.5-0.2,1c0,0.2,0,0.3,0,0.5c-0.1,1-0.2,2-0.2,3.1
            c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
            H67c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.1-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.1-2.3c0.1-0.9,0.1-1.8,0.1-2.8
            c0-1,0.1-2,0.1-3.1c0-1.1,0-2.1,0-3.1V2.7C68.6,2.5,68.6,2.2,68.6,2z"
          />
          <path
            fill="#ffffff"
            d="M81.7,5.7c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2s-0.3-0.1-0.5-0.2c-0.3-0.1-0.7-0.2-1.1-0.2
            c-0.4,0-0.7-0.1-1-0.1c-0.2,0-0.3,0-0.4,0.1C78.1,4.8,78,5,78,5.3c-0.6-0.3-1.2-0.4-1.9-0.4c-0.8,0-1.5,0.2-2.2,0.5
            c-0.7,0.3-1.4,0.8-2,1.4c-0.6,0.6-1,1.3-1.4,2.1c-0.4,0.8-0.5,1.6-0.5,2.6c0,0.6,0.1,1.2,0.3,1.8c0.2,0.5,0.5,1,0.9,1.4
            c0.4,0.4,0.9,0.7,1.4,0.9c0.5,0.2,1.2,0.3,1.8,0.3c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0,0.3,0.1,0.5,0.1,0.7
            c0.1,0.2,0.3,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0h0.8c0.2,0,0.3,0,0.4,0c0.4,0,0.6-0.2,0.8-0.3c0.2-0.2,0.2-0.5,0.3-0.9
            c0.2-1.3,0.3-2.7,0.3-4.1c0.1-1.4,0.1-2.8,0.1-4.1C81.7,6,81.7,5.8,81.7,5.7z M77.9,10c0,0.6-0.1,1.1-0.1,1.7
            c-0.3,0.3-0.7,0.6-1,0.7c-0.4,0.2-0.7,0.2-1.1,0.2c-0.6,0-1.1-0.2-1.4-0.5c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.2-0.9
            c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.5,0.8-0.7C75.8,8,76.2,8,76.6,8c0.3,0,0.5,0,0.8,0.1c0.2,0,0.5,0.1,0.7,0.2
            C78,8.8,78,9.4,77.9,10z"
          />
          <path
            fill="#ffffff"
            d="M93.8,6.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.7-0.3-1.1-0.4
            c-0.4-0.1-0.7-0.1-1-0.1c-0.6,0-1.2,0.1-1.8,0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.4,0.2-0.8,0.4-1.2,0.7c0-0.1,0-0.2,0-0.3
            c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.5,0-0.7,0.1
            c-0.1,0-0.1,0-0.1,0h0c-0.2,0-0.4,0-0.5,0.1C84.5,5,84.3,5,84.2,5c-0.3,0.1-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
            c0,0.3,0,0.5,0,0.8v0.8c0,1.1,0,2.2,0.1,3.4c0.1,1.1,0.2,2.2,0.3,3.3c0.1,0.3,0.1,0.6,0.3,0.8c0.1,0.2,0.4,0.3,0.9,0.3
            c0.1,0,0.2,0,0.3,0h0.7c0.1,0,0.2,0,0.3,0c0.5,0,0.8-0.1,0.9-0.2c0.2-0.1,0.2-0.3,0.2-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2
            c-0.1-0.9-0.2-1.8-0.2-2.7c-0.1-0.9-0.1-1.8-0.1-2.8c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.1,0.8-0.2,1.1-0.2c0.3,0,0.5,0.1,0.6,0.3
            c0.1,0.2,0.2,0.5,0.2,0.8c0,0.9,0,1.6,0,2.2c0,0.6,0,1.1-0.1,1.5c0,0.4-0.1,0.7-0.1,1c0,0.2,0,0.4,0,0.6c0,0.5,0.2,0.8,0.7,0.9
            c0.3,0.1,0.7,0.1,1,0.2c0.3,0,0.6,0.1,0.8,0.1c0.4,0,0.6-0.1,0.7-0.3c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.6,0.2-1.3,0.2-1.9
            c0.1-0.6,0.1-1.3,0.2-1.9c0-0.6,0.1-1.1,0.1-1.7c0-0.5,0-1,0-1.3C94.2,7.2,94.1,6.6,93.8,6.2z"
          />
          <path
            fill="#ffffff"
            d="M106.1,8.4c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
            c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
            c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
            c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.3-0.1
            c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
            c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
            c0.1-0.1,0.1-0.3,0.1-0.5C106.4,9.4,106.3,8.9,106.1,8.4z M100.9,9.3c-0.7,0.1-1.4,0.1-2,0.1C99,9,99.3,8.6,99.8,8.3
            c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C102.3,9.2,101.6,9.3,100.9,9.3z"
          />
          <path
            fill="#ffffff"
            d="M118.1,7.8c-0.1-0.2-0.3-0.3-0.4-0.5c-0.6-0.6-1.3-1-2.2-1.2c0-0.2,0-0.3,0.1-0.3c0-0.1,0-0.1,0-0.2
            c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3,0-0.6-0.1-0.8-0.1c-0.7,0-1.5,0.1-2.2,0.4
            c-0.7,0.3-1.3,0.7-1.9,1.1c0,0,0,0,0,0c-0.6,0.5-1,1.1-1.4,1.8c-0.4,0.7-0.5,1.5-0.5,2.4c0,0.9,0.2,1.6,0.4,2.3
            c0.3,0.7,0.7,1.2,1.2,1.7c0.5,0.4,1.2,0.8,1.9,1c0.8,0.2,1.6,0.3,2.5,0.3c0.7,0,1.4-0.1,2-0.3c0.7-0.2,1.3-0.5,1.8-1
            c0.5-0.4,1-1,1.3-1.6c0.3-0.6,0.5-1.4,0.5-2.2C119,9.7,118.7,8.7,118.1,7.8z M115.4,11.6c-0.1,0.3-0.3,0.5-0.6,0.6
            c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.4-0.4-0.5-0.6
            c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.8,0.2-1.4,0.7-1.9c0.5-0.5,1.1-0.8,1.8-0.9c0,0.2,0,0.4,0,0.5c0,0.1,0.1,0.2,0.2,0.3
            c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.4,0.2c0.4,0.1,0.7,0.3,1,0.6c0.2,0.3,0.4,0.6,0.4,1C115.6,11.1,115.5,11.3,115.4,11.6z"
          />
          <path
            fill="#ffffff"
            d="M130.6,9.2c0-0.1,0-0.2,0-0.3c-0.1-1-0.2-2-0.2-3c-0.1-0.4-0.2-0.6-0.4-0.7C129.8,5,129.5,5,129.1,5
            c-0.2,0-0.4,0-0.7,0c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.2-0.9,0.4c-0.2,0.2-0.2,0.4-0.2,0.7c0,0.1,0,0.4,0.1,0.7
            c0,0.3,0.1,0.8,0.1,1.3c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.9,0.1,1.4c0,0.6,0.1,1.2,0.1,1.9c-0.4,0.3-0.8,0.5-1.2,0.6
            c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0-1.1,0.1-1.7c0-0.6,0.1-1.1,0.1-1.6
            c0,0,0,0,0,0c0-0.5,0.1-0.9,0.1-1.2c0-0.4,0.1-0.6,0.1-0.8c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.3
            C123.2,5.1,123,5,122.8,5c-0.2,0-0.5,0-0.7,0c-0.5,0-0.8,0.1-1,0.2s-0.4,0.4-0.4,0.8c-0.1,0.6-0.2,1.1-0.2,1.7c0,0.1,0,0.1,0,0.2
            c-0.1,0.6-0.1,1.3-0.2,1.9c0,0.6-0.1,1.1-0.1,1.7c0,0.5,0,1,0,1.4c0,0.7,0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,0.9
            c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.7,0.1,1,0.1c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.2-0.5,1.7-0.8c0,0.1,0,0.2,0,0.3
            c0,0.1,0,0.2,0,0.3c0,0.4,0.3,0.7,0.8,0.7c0.3,0,0.7,0,1.2-0.1c0.4-0.1,0.9-0.2,1.2-0.3c0.3-0.1,0.4-0.3,0.5-0.5
            c0.1-0.2,0.1-0.5,0.1-0.8c0-0.2,0-0.5,0-0.8v-0.8C130.7,11.5,130.7,10.3,130.6,9.2z"
          />
          <path
            fill="#ffffff"
            d="M137.5,8.5c0.1,0.1,0.3,0.2,0.6,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
            c0.1-0.3,0.1-0.6,0.2-1c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3c-0.4-0.1-0.9-0.3-1.5-0.4
            c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7c-0.5,0.3-0.8,0.7-1.1,1.1s-0.4,0.9-0.4,1.4
            c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.1,0.3,0.2,0.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5
            c0.3,0.1,0.6,0.3,0.8,0.4c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1
            c-0.3-0.1-0.6-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.5,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7
            c0,0.2-0.1,0.3-0.1,0.5c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2
            c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.8-0.3,1.2-0.5c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.2,0-0.5-0.1-0.6
            c-0.1-0.3-0.2-0.5-0.3-0.8c-0.2-0.4-0.6-0.7-0.9-1c-0.2-0.1-0.4-0.3-0.7-0.4c0,0,0,0,0,0c-0.2-0.1-0.3-0.2-0.5-0.3
            c-0.4-0.2-0.8-0.3-1.2-0.5c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
            c0.2,0,0.4,0,0.7,0.1v0.2C137.4,8.2,137.4,8.4,137.5,8.5z"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(140, 30)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default MiscellaneousLink;
